import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["openedAt", "paoMonths", "printedExpiresAt", "card", "heading", "date", "detail", "reminder", "reminderRow", "warningRow"]
  static values = { channels: String, reminderLeadDays: Number }

  connect() {
    this.calculate()
  }

  warningRowTargetConnected() {
    this.calculate()
  }

  calculate() {
    const printedExpiresAt = this.printedExpiresAtTarget.value

    if (printedExpiresAt) {
      this.showExpiration(this.parseDate(printedExpiresAt), "Printed on the packaging")
      return
    }

    if (this.paoMonthsTarget.dataset.paoUnsure === "true") {
      this.showUnsure()
      return
    }

    const openedAt = this.openedAtTarget.value
    const paoMonths = parseInt(this.paoMonthsTarget.value)

    if (!openedAt || !paoMonths) {
      this.cardTarget.classList.add("hidden")
      return
    }

    const [year, month, day] = openedAt.split("-").map(Number)
    const expiresDate = new Date(year, month - 1 + paoMonths, day)

    if (expiresDate.getDate() !== day) {
      expiresDate.setDate(0)
    }

    this.showExpiration(expiresDate, `${paoMonths} months after opening`)
  }

  showExpiration(expiresDate, detail) {
    this.headingTarget.classList.remove("hidden")
    this.headingTarget.textContent = "Expires"
    this.dateTarget.textContent = this.formatDate(expiresDate)
    this.detailTarget.textContent = detail
    this.updateReminder(expiresDate)
    this.toggleReminderRows(true)

    this.cardTarget.classList.remove("hidden")
  }

  showUnsure() {
    this.headingTarget.classList.add("hidden")
    this.dateTarget.textContent = "No expiration date will be set."
    this.detailTarget.textContent = "You can update this any time."
    this.toggleReminderRows(false)

    this.cardTarget.classList.remove("hidden")
  }

  updateReminder(expiresDate) {
    if (!this.hasReminderTarget) return

    const reminderDate = new Date(expiresDate)
    reminderDate.setDate(reminderDate.getDate() - this.reminderLeadDaysValue)

    const today = new Date()
    today.setHours(0, 0, 0, 0)

    if (reminderDate > today) {
      this.reminderTarget.textContent =
        `We'll remind you by ${this.channelsValue} on ${this.formatDate(reminderDate)}.`
    } else {
      this.reminderTarget.textContent =
        `This product expires within ${this.reminderLeadDaysValue} days.`
    }
  }

  toggleReminderRows(show) {
    if (this.hasReminderRowTarget) this.reminderRowTarget.classList.toggle("hidden", !show)
    if (this.hasWarningRowTarget) this.warningRowTarget.classList.toggle("hidden", !show)
  }

  formatDate(date) {
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric"
    })
  }

  parseDate(value) {
    const [year, month, day] = value.split("-").map(Number)

    return new Date(year, month - 1, day)
  }
}
